import { z } from "zod";

const tariffFamilySchema = z.enum(["white", "black"]);
const tariffTierSchema = z.enum(["basic", "pro"]);
const activationResultSchema = z.enum(["extended", "reactivated", "created"]);

const inviteStatusSchema = z.enum(["active", "archived"]);

export const inviteResponseSchema = z.object({
  id: z.string(),
  code: z.string(),
  tariff_family: tariffFamilySchema,
  tariff_tier: tariffTierSchema,
  duration_days: z.number(),
  traffic_bytes: z.number(),
  max_uses: z.number(),
  used_count: z.number(),
  expires_at: z.string().nullable(),
  notes: z.string().nullable(),
  status: inviteStatusSchema,
  archived_at: z.string().nullable(),
  created_at: z.string(),
});

export const inviteListResponseSchema = z.object({
  items: z.array(inviteResponseSchema),
  total: z.number(),
  limit: z.number(),
  offset: z.number(),
});

export const createInviteRequestSchema = z.object({
  tariff_family: tariffFamilySchema,
  tariff_tier: tariffTierSchema,
  duration_days: z.number().int().gt(0).lte(1825),
  traffic_bytes: z.number().int().gt(0),
  max_uses: z.number().int().gte(1).lte(100),
  expires_at: z.string().nullable().optional(),
  notes: z.string().max(500).nullable().optional(),
});

export const redeemInviteRequestSchema = z.object({
  code: z.string().min(4).max(32),
});

export const redeemInviteResponseSchema = z.object({
  result: activationResultSchema,
  subscription_id: z.string(),
  tariff_family: tariffFamilySchema,
  tariff_tier: tariffTierSchema,
  expires_at: z.string(),
  traffic_limit_bytes: z.number(),
});
